module.exports = __webpack_public_path__ + "img/img8.1aad05af.png";